import React from "react";
import {FOBBetslip} from "../../../features/betslip/fob.service";
import iconLock from "../../../assets/feather/lock.svg";
import {OddsFlash} from "../components/odds-flash";
import jokeyIcon from "../../../assets/img/jokey.png";

function isEntrySelectable(entry: any): boolean {
    if (entry?.show === false || entry?.bettable === false) {
        return false;
    }
    return !!((entry?.win_odds && Number(entry.win_odds) > 1) || entry?.status === 'o');
}

function OddsValue({entry}: { entry: any }) {
    if (entry?.show === false || entry?.bettable === false) {
        return <img width={16} height={16} src={iconLock} alt="kapalı"/>;
    }
    if (entry?.win_odds && Number(entry.win_odds) > 1) {
        return <>{Number(entry.win_odds).toFixed(2)}</>;
    }
    return <>{entry?.status === 'o' ? 'KO' : '-'}</>;
}

function H2HSide({hippodrome, run, bettingTypeId, entry, pair}: any) {
    // Bir eşleşme ikiden az taraf içerebiliyor; `entry.*` erişimlerini tek tek korumak
    // yerine burada erkenden çıkılıyor.
    if (!entry) {
        return <div className={"h2h-side"}/>;
    }
    const horse = run.horseMap?.[String(entry.horse_no)];
    const opponent = pair.find((p: any) => p !== entry);
    const horseNos = [String(entry.horse_no), String(opponent?.horse_no)];
    const selection = {hippodrome, run, bettingType: Number(bettingTypeId), oddKey: horseNos.join('-'), horseNos};

    const isSelected = FOBBetslip.isAdded(selection) !== false;
    const selectable = isEntrySelectable(entry) && !!opponent;

    return (
        <div className={`h2h-side ${isSelected ? 'selected' : ''}`}
             style={{cursor: selectable ? 'pointer' : 'default', opacity: selectable ? 1 : 0.6}}
             onClick={() => {
                 if (selectable) {
                     FOBBetslip.toggle(selection);
                 }
             }}>
            {/* Forma görseli bültendeki kaynağın aynısı (sahibin kodu); yüklenemezse
                bültendeki gibi genel jokey ikonuna düşüyor. */}
            <img className={"h2h-silk"} width={22} height={22}
                 src={`https://medya-cdn.tjk.org/formaftp/${horse?.owner?.code}.jpg`}
                 onError={({currentTarget}) => {
                     currentTarget.onerror = null;
                     currentTarget.src = jokeyIcon;
                 }}
                 alt={horse?.jokey?.short_name ?? ''}/>
            <span className={"h2h-badge"}>{entry.horse_no}</span>
            <span className={"h2h-name"}>
                <span className={"text-xsmall text-bold text-truncate"}>{horse?.name ?? ''}</span>
                <span className={"h2h-jockey text-xxxsmall text-truncate"}>{horse?.jokey?.short_name ?? ''}</span>
            </span>
            <span className={"h2h-odds text-xsmall text-bold"}>
                <OddsFlash entry={entry}><OddsValue entry={entry}/></OddsFlash>
            </span>
        </div>
    );
}

export function FobH2HTable({hippodrome, run, bettingTypeId}: any) {
    const pairs: any[] = Object.values(run?.fob_h2h ?? {});

    if (!run?.fob_h2h_status || pairs.length === 0) {
        return (
            <div className="hint-text text-center p-3" style={{minHeight: "20vh"}}>
                <p className={"fs-6 mb-0 text-black"}>Bu koşuda Kim Geçer eşleşmesi bulunmuyor.</p>
            </div>
        );
    }

    return (
        <div className={"h2h-wrapper"}>
            {pairs.map((pair: any, index: number) => (
                <div className={"h2h-row"} key={`h2h-pair-${run.no}-${index}`}>
                    <H2HSide hippodrome={hippodrome} run={run} bettingTypeId={bettingTypeId}
                             entry={pair?.[0]} pair={pair}/>
                    <span className={"h2h-vs text-xxsmall text-bold"}>VS</span>
                    <H2HSide hippodrome={hippodrome} run={run} bettingTypeId={bettingTypeId}
                             entry={pair?.[1]} pair={pair}/>
                </div>
            ))}
        </div>
    );
}
